module.exports = __webpack_public_path__ + "img/calendar.9c08fd95.svg";